import { useQuery } from "@tanstack/react-query";
import ConfigHolder from "../../config/ConfigHolder";
import useDataStore from "../../store/useDataStore";
import useWidgetStore from "../../store/useWidgetStore";
import { useSettings } from "../../context/SettingsContext";
export const useUpdateCart = (formContext, options) => {
    const { api_key, widget_id } = useSettings();
    const defaultOptions = Object.assign(Object.assign({}, options), { enabled: false, networkMode: "always", cacheTime: 0, staleTime: 0 });
    const { booking, cart, consumer, language, selectedApptype, selectedResource, selectedCapacity, selectedCapacityGroups, setCart, getDaoAppointments, getDaoProducts } = useWidgetStore();
    const { apptypes, } = useDataStore();
    return useQuery(Object.assign(Object.assign({}, defaultOptions), { queryKey: ['widget-updateCart'], queryFn: async ({ signal }) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
            let url = ConfigHolder.getApiMethodUrl(api_key, widget_id, 'updateCart', 'checkout');
            let _appointments = getDaoAppointments(), _paymentMethod = formContext.getValues('paymentMethod'), 
            // A subscription or membership can only ever pay for an appointment. Its own line is
            // in the cart, so getDaoProducts would send it straight back as another one to buy —
            // the backend then adds a second one alongside the one it creates itself, and the cart
            // grows by one on every refetch (toggling direct/incasso on the mandate form is enough
            // to do it). Nothing else in the cart could be paid this way either, so send nothing.
            _products = (_paymentMethod === null || _paymentMethod === void 0 ? void 0 : _paymentMethod.startsWith('subscription')) || (_paymentMethod === null || _paymentMethod === void 0 ? void 0 : _paymentMethod.startsWith('membership'))
                ? []
                : getDaoProducts(), selectedSubscription = formContext.getValues('selectedSubscription');
            if (!selectedSubscription) {
                if ((_a = formContext.getValues('paymentMethod')) === null || _a === void 0 ? void 0 : _a.startsWith('membership_')) {
                    let pm = formContext.getValues('paymentMethod').substring(11);
                    if (pm.endsWith('mandate')) {
                        pm = pm.substring(0, pm.indexOf('_mandate'));
                    }
                    selectedSubscription = (_b = consumer.subscriptions) === null || _b === void 0 ? void 0 : _b.find((subscription) => subscription.id === parseInt(pm));
                }
            }
            let data = {
                order_id: (_c = cart.order_id) !== null && _c !== void 0 ? _c : '',
                giftCards: cart.giftCards,
                discounts: cart.discounts,
                appointments: _appointments.length > 0 ? [{
                        appTypeId: selectedApptype, // booking?.appointments[0]?.components[0]?.appointmentTypes,
                        resourceId: selectedResource,
                        capacity: selectedCapacity,
                        components: _appointments,
                        date: (_d = _appointments[0].date) !== null && _d !== void 0 ? _d : _appointments[0].time,
                        time: _appointments[0].time,
                        fields: (_e = consumer.fields) !== null && _e !== void 0 ? _e : {},
                        remark: (_f = booking.remark) !== null && _f !== void 0 ? _f : ((_g = consumer.remark) !== null && _g !== void 0 ? _g : '')
                    }] : [],
                products: _products,
                paymentMethod: formContext.getValues('paymentMethod'),
                paymentOption: formContext.getValues('paymentOption'),
                final: formContext.getValues('final') && formContext.getValues('paymentMethod') !== "alternate",
                widgetUrl: window.location.href,
                subscriptionId: (_h = selectedSubscription === null || selectedSubscription === void 0 ? void 0 : selectedSubscription.subscriptionId) !== null && _h !== void 0 ? _h : undefined,
                subscriptionTypeId: (_j = selectedSubscription === null || selectedSubscription === void 0 ? void 0 : selectedSubscription.id) !== null && _j !== void 0 ? _j : undefined
            };
            if ((_k = cart.order_id) === null || _k === void 0 ? void 0 : _k.startsWith('tmp_')) {
                let _consumer = {
                    hash: (_l = consumer.hash) !== null && _l !== void 0 ? _l : '',
                    id: (_m = consumer.id) !== null && _m !== void 0 ? _m : ''
                };
                data.customer = _consumer;
            }
            if (formContext.getValues("createMandate")) {
                data.createMandate = true;
            }
            const response = await fetch(url.href, {
                signal: signal,
                method: "POST",
                headers: {
                    'Content-Type': 'application/json', // checks this header if it's a POST, while calling the method getRestData.... That's not Restful
                    'X-OAnl-csrf-protection': 'on',
                    'accept': 'application/json+ld',
                },
                body: JSON.stringify(data)
            });
            let result = response.json();
            setCart(Object.assign(Object.assign({}, cart), { secureToken: (_o = response.headers.get('x-oanl-secure-token')) !== null && _o !== void 0 ? _o : '' }));
            return result;
        } }));
};
